<template>
	<div>
		<section>
			<div class="container">
				<div class="row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
						<div
							class="form--v10 px-3 py-4 px-md-5 mb-5 py-md-6 rounded--10 bg-color--light--1"
						>
							<form class="form">
								<div
									class="alert alert-danger"
									role="alert"
									id="alert"
									v-show="alert"
								></div>
								<div class="container">
									<H4 class="mb-4 text-center" v-if="!isSurety"
										>ثبت اطلاعات ضامن اول</H4
									>
									<H4 class="mb-4 text-center" v-if="isSurety">
										ویرایش اطلاعات ضامن اول
									</H4>

									<!-- NAME & LASTNAME -->
									<div class="row justify-content-between">
										<!-- NAME -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.name") }}</label
												>
												<input
													id="name"
													type="text"
													v-model.trim="$v.name.$model"
													class="form-control form-control-sm"
													:class="{ 'is-invalid': $v.name.$error }"
													@blur="$v.name.$touch()"
												/>
												<div class="invalid-feedback" v-if="!$v.name.required">
													ورود نام لازم است
												</div>
											</div>
										</div>
										<!-- LAST NAME -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.lastName") }}</label
												>
												<input
													id="lastName"
													type="text"
													v-model.trim="$v.lastName.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.lastName.$error }"
													@blur="$v.lastName.$touch()"
												/>
												<div
													class="invalid-feedback"
													v-if="!$v.lastName.required"
												>
													ورود نام خانوادگی لازم است
												</div>
											</div>
										</div>
									</div>

									<!-- gender&  FATHER NAME -->
									<div class="row justify-content-between">
										<!-- FATHER NAME -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.fatherName") }}</label
												>
												<input
													id="fatherName"
													type="text"
													v-model.trim="$v.fatherName.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.fatherName.$error }"
													@blur="$v.fatherName.$touch()"
												/>
												<div
													class="invalid-feedback"
													v-if="!$v.fatherName.required"
												>
													ورود نام پدر الزامی است
												</div>
											</div>
										</div>

										<!-- gender -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase form-check-inline form-check-label font-size--15 font-w--500"
													>{{ $t("register.gender") }}</label
												>

												<div class="form-check form-check-inline mt-2">
													<input
														id="gender"
														class="form-check-input"
														type="radio"
														name="inlineRadioOptions"
														value="m"
														v-model.trim="$v.gender.$model"
														:class="{ 'is-invalid': $v.gender.$error }"
														@blur="$v.gender.$touch()"
													/>
													<label
														class="form-check-label"
														for="inlineRadioMan"
														>{{ $t("register.male") }}</label
													>
												</div>
												<div class="form-check form-check-inline">
													<input
														class="form-check-input"
														type="radio"
														name="inlineRadioOptions"
														id="inlineRadioWoman"
														value="f"
														v-model.trim="$v.gender.$model"
														:class="{ 'is-invalid': $v.gender.$error }"
														@blur="$v.gender.$touch()"
													/>
													<label
														class="form-check-label"
														for="inlineRadioWoman"
														>{{ $t("register.female") }}</label
													>
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.gender.required"
												>
													ورود جنسیت الزامی است
												</div>
											</div>
										</div>
									</div>

									<!-- INCOME & INCOME-->
									<div class="row justify-content-between">
										<!-- MELLI CODE -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.melliCode") }}</label
												>
												<input
													id="melliCode"
													type="number"
													@wheel="$event.target.blur()"
													v-model.trim="$v.melliCode.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.melliCode.$error }"
													@blur="$v.melliCode.$touch()"
												/>
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.melliCode.checkMelliCode"
											>
												کد ملی معتبر نیست
											</div>
										</div>
										<!-- INCOME -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.income") }}</label
												>

												<vue-numeric
													id="income"
													separator=","
													v-model.trim="$v.income.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.income.$error }"
													@blur="$v.income.$touch()"
												></vue-numeric>
												<div
													class="invalid-feedback"
													v-if="!$v.income.required"
												>
													حدود درآمد را وارد کنید
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.income.minValue"
												>
													حدود درآمد را صحیح وارد کنید
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.income.maxValue"
												>
													حدود درآمد را به میلیون ریال وارد کنید
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- MOBILE & PHONE NUMBER -->
								<div class="row justify-content-between">
									<!-- MOBILE NUMBER  -->
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.mobileNumber") }}</label
											>
											<input
												id="mobileNumber"
												type="number"
												@wheel="$event.target.blur()"
												v-model.trim="$v.mobileNumber.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.mobileNumber.$error }"
												@blur="$v.phone.$touch()"
											/>
											<div
												class="invalid-feedback"
												v-if="!$v.mobileNumber.required"
											>
												ورود شماره همراه لازم است
											</div>
											<div
												class="invalid-feedback"
												v-if="
													!$v.mobileNumber.minLength ||
													!$v.mobileNumber.maxLength
												"
											>
												شماره همراه نا معتبر است
											</div>
										</div>
									</div>

									<!-- PHONE -->
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.phone") }}</label
											>
											<input
												id="phone"
												type="number"
												@wheel="$event.target.blur()"
												v-model.trim="$v.phone.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.phone.$error }"
												@blur="$v.phone.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.phone.required">
												ورود تلفن لازم است
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.phone.minLength || !$v.phone.maxLength"
											>
												شماره تلفن نا معتبر است
											</div>
										</div>
									</div>
								</div>

								<!-- JOB CLASS & JOB -->
								<div class="row justify-content-between">
									<!-- JOB CLASS -->
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.jobclass") }}</label
											>
											<select
												class="form-control form-control-sm"
												id="jobclass"
												v-model.trim="$v.jobClass.$model"
												:class="{ 'is-invalid': $v.jobClass.$error }"
											>
												<option value="0">{{ $t("register.staff") }}</option>
												<option value="1">{{
													$t("register.selfEmployment")
												}}</option>
												<option value="2">{{
													$t("register.pensioner")
												}}</option>
											</select>
											<div
												class="invalid-feedback"
												v-if="!$v.jobClass.required"
											>
												حوزه شغلی خود را وارد کنید
											</div>
										</div>
									</div>

									<!-- JOB -->
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.job") }}</label
											>
											<input
												id="job"
												type="text"
												v-model.trim="$v.job.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.job.$error }"
												@blur="$v.job.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.job.$required">
												عنوان شغلی خود را وارد کنید
											</div>
											<small id="" class="form-text text-danger">{{
												$t("register.jobDanger")
											}}</small>
										</div>
									</div>
								</div>

								<!-------------------------------------     address  ------------------------------------------->
								<hr />
								<h4 class="text-dark text-align-center">
									{{ $t("register.addressInfo") }}
								</h4>
								<br />

								<!-- ADRESS -->
								<div class="form-row justify-content-between">
									<!-- PROVINCE -->
									<div class="col">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.province") }}</label
											>
											<input
												id="province"
												type="text"
												v-model.trim="$v.province.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.province.$error }"
												@blur="$v.province.$touch()"
											/>
											<div
												class="invalid-feedback"
												v-if="!$v.province.required"
											>
												ورود استان لازم است
											</div>
										</div>
									</div>

									<!-- CITY -->
									<div class="col">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.city") }}</label
											>
											<input
												id="city"
												type="text"
												v-model.trim="$v.city.$model"
												:class="{ 'is-invalid': $v.city.$error }"
												class="form-control"
												style="radius=10px"
												@blur="$v.city.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.city.required">
												ورود شهر لازم است
											</div>
										</div>
									</div>

									<!-- ADDRESS -->
									<div class="col-md-8">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.address") }}</label
											>
											<textarea
												id="address"
												type="text"
												v-model.trim="$v.address.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.address.$error }"
												@blur="$v.address.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.address.required">
												ورود آدرس لازم است
											</div>
										</div>
									</div>
								</div>

								<!-- ZIP CODE -->
								<div class="form-row">
									<!-- ZIP CODE -->
									<div class="col-md-4">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.zipCode") }}</label
											>
											<tooltip
												effect="scale"
												trigger="click"
												placement="top"
												content=" برای دریافت کد پستی خودمی توانید به سامانه
												<span
													><a
														href='https://epostcode.post.ir/'
														target='_blank'
														rel='noopener noreferrer'
														>کد پستی</a
													></span
												>
												مراجعه کنید ."
											>
												<a class="popover_btn">
													راهنما
												</a>
											</tooltip>
											<input
												id="zipCode"
												type="number"
												@wheel="$event.target.blur()"
												v-model.trim="$v.zipCode.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.zipCode.$error }"
												@blur="$v.zipCode.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.zipCode.required">
												{{ $t("customerData.Errors.postalcode required") }}
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.zipCode.checkZipCode"
											>
												{{ $t("customerData.Errors.postalcode.notEnvalid") }}
											</div>
										</div>
									</div>
								</div>
								<br />
								<br />
								<div
									class="d-flex justify-content-between align-items-center flex-column"
								>
									<button
										class="btn btn-bg--primary btn-size--md btn-hover--3d"
										@click.prevent="checkSurety"
									>
										<span class="btn__text" v-if="!isSurety">ثبت</span>
										<span class="btn__text" v-if="isSurety">ویرایش</span>
									</button>
								</div>
							</form>
							<!-- end of form -->
						</div>
						<!-- end of from area -->
					</div>
					<!-- end of col -->
				</div>
				<!-- end of row -->
			</div>
			<!-- end of container -->
		</section>
		<!-- =========== End of Body ============ -->
	</div>
</template>

<script>
	// import VuePersianDatetimePicker from "vue-persian-datetime-picker";
	// import {
	//   required,
	//   minValue,
	//   minLength,
	//   maxLength,
	// } from "vuelidate/lib/validators";
	import VueNumeric from "vue-numeric";
	import { tooltip } from "vue-strap";
	import { surtyValidationMixin } from "../../mixins/validationMixin";
	export default {
		data() {
			return {
				alert: false,
				errors: [],

				name: "",
				lastName: "",
				fatherName: "",
				melliCode: "",
				jobClass: "",
				job: "",
				mobileNumber: "",
				phone: "",
				province: "",
				city: "",
				address: "",
				zipCode: "",
				income: "",
				gender: "",
			};
		},
		mixins: [surtyValidationMixin],

		mounted() {
			// this.getUserData();
			// this.getUsersSyretys();
			this.getSurtyData();
		},
		computed: {
			// getUsersSyretys() {
			//   return this.$store.getters.getUsersSyretys;
			// },
			isSurety() {
				return this.$store.getters.hasFirstSurety;
			},
		},
		methods: {
			getSurtyData() {
				// if (this.getUsersSyretys[0]) {
				if (this.isSurety) {
					let load = this.$loading.show();
					this.$store
						.dispatch("getSurtyData", this.$store.getters.getUsersFirstSuretyID)
						.then((response) => {
							console.log("response: ", response);
							this.name = response.body.first_name;
							this.lastName = response.body.last_name;
							this.melliCode = response.body.melli_code;
							this.fatherName = response.body.father_name;
							this.mobileNumber = response.body.mobile_number;
							this.phone = response.body.phone_number;
							this.province = response.body.province;
							this.city = response.body.city;
							this.address = response.body.address;
							this.income = response.body.estimate_income;
							(this.jobClass = response.body.job_class),
								(this.job = response.body.job),
								(this.zipCode = response.body.postal_code);
							this.gender = response.body.gender;
							load.hide();
						})
						.catch((err) => {
							console.log("err:  ", err);
							load.hide();
						});
				}
			},

			checkSurety() {
				if (this.$store.getters.hasFirstSurety) {
					// upate surety
					const surety_data = {
						suretyID: this.$store.getters.getUsersFirstSuretyID,
						first_name: this.name,
						last_name: this.lastName,
						melli_code: this.melliCode,
						father_name: this.fatherName,
						mobile_number: this.mobileNumber,
						phone_number: this.phone,
						// workplace_number: this.phone,
						province: this.province,
						city: this.city,
						address: this.address,
						job_class: this.jobClass,
						job: this.job,
						estimate_income: this.income,
            postal_code: this.zipCode,
            gender:this.gender
					};
					this.$swal({
						theme: "Bootstrap 4",
						icon: "error",
						title: "هشدار",
						text:
							"در صورت ویرایش اطلاعات، وضعیت کاربری شما به <<درحال بررسی>> تغییر خواهد کرد و دوباره باید منتظر تایید اطلاعات باشید",
						showCancelButton: true,
						confirmButtonText: "تایید",
						cancelButtonText: "انصراف",
						confirmButtonColor: "#3085d6",
						cancelButtonColor: "#d33",
					}).then((result) => {
						if (result.value) {
							this.$v.$touch();
							if (this.$v.$invalid) {
								// this.submitStatus = "ERROR";
								errorMsgInvalidField.show();
								console.log(this.$v);
							} else {
								this.$store
									.dispatch("updateSurety", surety_data)
									.then((resp) => {
										//   this.$router.push("/customer");
										successMsgUpdated.show();

										console.log(resp);
									})
									.catch((err) => {
										console.log(err);
										this.alert = true;
										this.$noty.error(err.body.Error);
										// errorMsgUpdated.text(err.body.Error);
									});
							}
						}
					});
				} else {
					const surety_data = {
						first_name: this.name,
						last_name: this.lastName,
						melli_code: this.melliCode,
						father_name: this.fatherName,
						mobile_number: this.mobileNumber,
						phone_number: this.phone,
						// workplace_number: this.phone,
						province: this.province,
						city: this.city,
						address: this.address,
						job_class: this.jobClass,
						job: this.job,
						estimate_income: this.income,
            postal_code: this.zipCode,
            gender:this.gender
					};
					this.$v.$touch();
					if (this.$v.$invalid) {
						// this.submitStatus = "ERROR";
						errorMsgInvalidField.show();
					} else {
						let load = this.$loading.show();
						this.$store
							.dispatch("createSurety", surety_data)
							.then((resp) => {
								//   this.$router.push("/customer");
								localStorage.setItem("first_surety_ID", resp.body.id);
								this.$store.commit("setFirstSuretyID", resp.body.id);
								//this.getSurtyData();
								load.hide();
								successMsgCreated.show();

								this.$router.push("/customer/upload-first-surty-docs");
							})
							.catch((err) => {
								console.log(err);
								this.alert = true;
								load.hide();
								errorMsgCreated.show();
							});
					}
				}
			},
		},

		components: {
			VueNumeric,
			tooltip,
		},
	};

	import Noty from "noty";
	import "noty/lib/noty.css";
	import "noty/lib/themes/nest.css";

	var successMsgCreated = new Noty({
		type: "success",
		layout: "bottomLeft",
		theme: "nest",
		text: "اطلاعات ضامن اول با موفقیت ثبت شد",
		timeout: "4000",
		progressBar: true,
		closeWith: ["click"],
		//   killer: true,
	});
	var successMsgUpdated = new Noty({
		type: "success",
		layout: "bottomLeft",
		theme: "nest",
		text: "اطلاعات ضامن اول با موفقیت ویرایش شد",
		timeout: "4000",
		progressBar: true,
		closeWith: ["click"],
		//   killer: true,
	});
	var errorMsgCreated = new Noty({
		type: "error",
		layout: "bottomLeft",
		theme: "nest",
		text: "در ثبت اطلاعات ضامن اول مشکلی پیش آمد",
		timeout: "4000",
		progressBar: true,
		closeWith: ["click"],
		//   killer: true,
	});
	// var errorMsgUpdated = new Noty({
	//   type: "error",
	//   layout: "bottomLeft",
	//   theme: "nest",
	//   timeout: "4000",
	//   progressBar: true,
	//   closeWith: ["click"],
	//   //   killer: true,
	// });
	var errorMsgInvalidField = new Noty({
		type: "alert",
		layout: "bottomLeft",
		theme: "nest",
		text: "فیلد های مشخص شده را کامل نمایید ",
		timeout: "4000",
		progressBar: true,
		closeWith: ["click"],
		//   killer: true,
	});
</script>

<style>
	.vpd-icon-btn {
		display: flex;
		width: 1%;
		cursor: pointer;
		padding: 0 10px;
	}
</style>
